import { render, staticRenderFns } from "./DeleteContract.vue?vue&type=template&id=5f8e7024&scoped=true"
import script from "./DeleteContract.vue?vue&type=script&lang=js"
export * from "./DeleteContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e7024",
  null
  
)

export default component.exports